import { useContext, useEffect } from 'react';

import { UserCountryContext } from 'context/UserCountryContext';

const DEFAULT_SUBDOMAIN = 'uk';

const SUBDOMAINS: Record<string, string> = {
  gb: 'uk',
  uk: 'uk',
  ie: 'ie',
  de: 'de',
  sg: 'sg',
  it: 'italy',
  us: 'usa',
};

export const getCreditReportUrl = (countryCode?: string | null) => {
  const subdomain = (countryCode && SUBDOMAINS[countryCode.toLowerCase()]) || DEFAULT_SUBDOMAIN;

  return `https://${subdomain}.globaldatabase.com/product/credit_report`;
};

export const useCreditReportUrl = () => {
  const { countryCode, fetchCountryCode } = useContext(UserCountryContext);

  useEffect(() => {
    fetchCountryCode();
  }, [fetchCountryCode]);

  return getCreditReportUrl(countryCode);
};
